module.exports = __webpack_public_path__ + "assets/img/27_1249_big.d38ef50c.jpg";